var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#828282"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7795 46.365C67.6858 46.365 70.8546 43.2132 70.8546 39.3252C70.8546 35.4372 67.6858 32.2855 63.7795 32.2855M67.0322 54.0153C68.1987 54.0954 69.3585 54.26 70.5004 54.5158C72.0871 54.825 73.9955 55.4722 74.6748 56.8891C75.1084 57.7966 75.1084 58.8531 74.6748 59.7628C73.9977 61.1797 72.0871 61.8247 70.5004 62.1494M36.2199 46.365C32.3136 46.365 29.1448 43.2132 29.1448 39.3252C29.1448 35.4372 32.3136 32.2855 36.2199 32.2855M32.9673 54.0153C31.8008 54.0954 30.6409 54.26 29.499 54.5158C27.9124 54.825 26.0039 55.4722 25.3268 56.8891C24.8911 57.7966 24.8911 58.8531 25.3268 59.7628C26.0017 61.1797 27.9124 61.8247 29.499 62.1494M49.9884 55.5313C57.9037 55.5313 64.6659 56.7235 64.6659 61.4945C64.6659 66.2633 57.9484 67.5 49.9884 67.5C42.0709 67.5 35.3109 66.3078 35.3109 61.5368C35.3109 56.7657 42.0284 55.5313 49.9884 55.5313ZM49.9882 48.726C44.768 48.726 40.5824 44.56 40.5824 39.3619C40.5824 34.166 44.768 30 49.9882 30C55.2085 30 59.3941 34.166 59.3941 39.3619C59.3941 44.56 55.2085 48.726 49.9882 48.726Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersGroup);
export default __webpack_public_path__ + "static/media/users_group.faa75b2b.svg";
export { ForwardRef as ReactComponent };